export const CONTACT_EMAIL = import.meta.env.VITE_CONTACT_EMAIL;

export const REWARD_CONFIG = {
  elementCount: 250,
  elementSize: 75,
  emoji: ['📧', '✉️', '📨', '📩'],
  lifetime: 500,
  spread: 150,
  startVelocity: 50,
  zIndex: -1,
};
